// Function to get the current query parameters as a string
function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  return params.toString(); // Returns query parameters as a string
}

// Function to update all links inside the filter list with the current query parameters
function updateFilterLinks() {
  const filterLinks = document.querySelectorAll('#filter-form__list-type--sidebar a');
  const queryParams = getQueryParams();

  filterLinks.forEach(link => {
    const url = new URL(link.href); // Get the existing URL from the href attribute
    
    // Remove existing params and merge them with the current query params
    url.search = queryParams ? `?${queryParams}` : '';

    link.href = url.toString(); // Update the href with the new parameters
  });
}

// Initial update when the page loads
updateFilterLinks();

// Watch for URL changes and update the links accordingly
window.addEventListener('popstate', updateFilterLinks);

// Also monitor for programmatic URL changes (e.g., via pushState/replaceState)
const originalPushState = window.history.pushState;
const originalReplaceState = window.history.replaceState;

// Override pushState and replaceState to detect when they are called
window.history.pushState = function (...args) {
  originalPushState.apply(window.history, args);
  updateFilterLinks(); // Update links after the URL changes
};

window.history.replaceState = function (...args) {
  originalReplaceState.apply(window.history, args);
  updateFilterLinks(); // Update links after the URL changes
};

document.addEventListener('DOMContentLoaded', () => {
  // Attach event listener for the "Add Carton" button
  const cartonButton = document.querySelector('.product-form__cart-submit[data-carton-quantity]');
  if (cartonButton) {
    cartonButton.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent form submission or default button action

      // Get the carton quantity from the data attribute
      const cartonQuantity = parseInt(cartonButton.getAttribute('data-carton-quantity'), 10) || 0;

      if (cartonQuantity > 0) {
        // Find and update quantity inputs
        const quantityInputs = document.querySelectorAll('.product-form__input--quantity, .quantity-input [data-quantity-input]');
        quantityInputs.forEach(input => {
          const currentValue = parseInt(input.value, 10) || 0;
          const max = parseInt(input.getAttribute('max'), 10) || null;

          // Calculate the new value
          let newValue = currentValue + cartonQuantity;
          if (max) {
            newValue = Math.min(newValue, max); // Respect the max value if set
          }

          input.value = newValue;
          input.dispatchEvent(new Event('change')); // Trigger change event
        });
      }
    });
  } else {
    console.error('Carton button not found. Ensure the selector is correct.');
  }
});




document.addEventListener("DOMContentLoaded", () => {
  const subtotalElement = document.querySelector(".quick-cart__footer-subtotal .ff-product-price");
  const checkoutButton = document.querySelector(".quick-cart__submit");

  if (!subtotalElement || !checkoutButton) {
    console.error("Required elements not found");
    return;
  }

  // Function to get the numeric value of the subtotal (Dollar format)
  const getSubtotalValue = () => {
    // Example format: "$5,352.00 USD" -> "5,352.00"
    let text = subtotalElement.textContent.trim();
    
    // Remove everything that isn't a digit, comma, or dot
    text = text.replace(/[^\d.,]/g, '');
    
    // Remove the ',' thousands separators
    text = text.replace(/,/g, '');
    
    // Parse as float
    const numericValue = parseFloat(text);
    
    return isNaN(numericValue) ? 0 : numericValue;
  };

  const updateCheckoutButton = () => {
    const subtotal = getSubtotalValue();
    if (subtotal <= 299) {
      checkoutButton.disabled = true;
      checkoutButton.textContent = "Minimum order is $300";
    } else {
      checkoutButton.disabled = false;
      checkoutButton.textContent = "Checkout";
    }
  };

  // Initial check
  updateCheckoutButton();

  // Observe changes in the subtotal text
  const observer = new MutationObserver(() => {
    updateCheckoutButton();
  });
  observer.observe(subtotalElement, { childList: true, characterData: true, subtree: true });

  // Clean up when the page unloads
  window.addEventListener("unload", () => {
    observer.disconnect();
  });
});


document.addEventListener("DOMContentLoaded", function () {
    // Select the quantity input field
    let quantityInput = document.querySelector('[data-product-page-quantity-field]')
    
    // Select the "Add to Cart" button
    let addToCartButton = document.querySelector('[data-add-to-cart]');

    // Function to disable/enable the button based on quantity
    function toggleAddToCartButton() {
        if (quantityInput && addToCartButton) {
            if (parseInt(quantityInput.value) === 0) {
                addToCartButton.disabled = true;
                addToCartButton.classList.add("disabled"); // Optional: Add CSS class for styling
            } else {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove("disabled");
            }
        }
    }

    // Run on page load
    toggleAddToCartButton();

    // Add event listener for quantity change
        quantityInput.addEventListener("input", toggleAddToCartButton);
    quantityInput.addEventListener("change", toggleAddToCartButton);
});